<template>
  <div class="repertContainer">
    <md-field>
      <md-input-item
        title="姓名"
        v-model="form.name"
        placeholder="請輸入姓名"
        clearable
      />
      <md-input-item
        title="聯系電話"
        type="phone"
        v-model="form.mobile"
        placeholder="請輸入聯系電話"
        clearable
      />
      <md-input-item
        title="證件號"
        v-model="form.certificateNo"
        placeholder="請再次證件號"
        no-border
        clearable
      />
      <div class="tip">
        <md-notice-bar :multi-rows="true" type="warning"
          >該證件號用於當地實名認證，我們會嚴格保密該信息</md-notice-bar
        >
      </div>
      <md-button
        type="warning"
        :loading="loading"
        style="margin: 0.4rem 0"
        @click="submitpas"
        >保存</md-button
      >
    </md-field>

    <div class="declared_container" v-if="declarantList.length > 0">
      <div style="width: 95%">
        <p class="title">歷史申報人</p>
        <table border="0">
          <tr class="header">
            <th>姓名</th>
            <th>聯系電話</th>
            <th>證件號</th>
            <th>操作</th>
          </tr>
          <tr
            v-for="(item, index) in declarantList"
            :key="index"
            class="content"

          >
            <td  @click="addDeclarant(item)">{{ item.name }}</td>
            <td  @click="addDeclarant(item)">{{ item.mobile }}</td>
            <td  @click="addDeclarant(item)">{{ item.certificateNo }}</td>
            <td>
              <div style="display: flex;align-items: center;justify-content: center">
<!--                <md-icon-->
<!--                  name="success-color"-->
<!--                  size="md"-->
<!--                  svg-->
<!--                  style="margin-right: 0.2rem"-->
<!--                  @click="addDeclarant(item)"-->
<!--                ></md-icon>-->
                <md-icon
                  name="clear"
                  color="gray"
                  size="md"
                  @click="deleteDeclarant(item, index)"
                ></md-icon>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Field,
  FieldItem,
  Button,
  InputItem,
  Toast,
  NoticeBar,
  Dialog
} from "mand-mobile";
import { isBlank } from "@/until/common.js";
import eventBus from "../../until/eventBus";

export default {
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [NoticeBar.name]: NoticeBar,
    [Dialog.name]: Dialog
  },
  name: "declarant",
  data() {
    return {
      form: {
        name: "",
        mobile: "",
        certificateNo: "",
        countryId: "158"
      },
      declarantList: [],
      loading: false
    };
  },
  mounted() {
    this.form.countryId = this.$route.query.countryId;
    this.getDeclareHistoryList();
  },
  methods: {
    getDeclareHistoryList() {
      this.http.APIASK(this.ports.declareHistoryList, "post", {}).then(res => {
        this.declarantList = res;
      });
    },
    submitpas() {
      if (isBlank(this.form.name)) {
        Toast.failed("請輸入姓名");
        return;
      }
      if (isBlank(this.form.mobile)) {
        Toast.failed("請輸入聯系電話");
        return;
      }
      if (isBlank(this.form.certificateNo)) {
        Toast.failed("請輸入證件號");
        return;
      }
      this.loading = true;
      this.http
        .APIASK(this.ports.saveDeclareOrder, "post", this.form)
        .then(res => {
          this.loading = false;
          Toast.succeed("添加申報人成功");
          this.form = {
            name: "",
            mobile: "",
            certificateNo: "",
            countryId: this.$route.query.countryId
          };
          this.getDeclareHistoryList();
          // eventBus.$emit('setDeclarant', res);
          // this.$router.go(-1);
        })
        .catch(err => {
          this.loading = false;
        });
    },
    addDeclarant(data) {
      this.http.APIASK(this.ports.checkEntrust, 'post', {
        type: 2,
        id: data.id
      }).then((res) => {
        eventBus.$emit('setDeclarant', data);
        this.$router.go(-1);
      }).catch(err=>{
        Dialog.alert({
          title: '提示',
          content: err.message,
          confirmText: '确定',
          onConfirm: () =>{
            eventBus.$emit('setDeclarant', data);
            this.$router.go(-1);
          },
        })
        console.log('qqewerr', err)
      });

    },
    deleteDeclarant(record, index) {
      Dialog.confirm({
        content: "请确认是否删除该申報人",
        confirmText: "确定",
        onConfirm: () => {
          this.http
            .APIASK(this.ports.deleteDeclare, "post", { id: record.id })
            .then(res => {
              this.declarantList.splice(index, 1);
            });
        }
      });
    }
  }
};
</script>

<style lang="less">
.repertContainer {
  .md-field-item-content:before {
    content: "";
    position: absolute;
    z-index: 2;
    -webkit-transform: scaleY(0.5) translateY(100%);
    transform: scaleY(0.5) translateY(100%);
    bottom: 0;
    left: 0;
    right: auto;
    top: auto;
    width: 100%;
    border-bottom: 0.02rem solid #e2e4ea;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
  }
  .md-field {
    padding: 0 0.4rem;
  }
  .md-field-item-title {
    text-align: left;
  }
  .tip {
    margin: 0.4rem 0;
  }

  .declared_container {
    background: white;
    padding: 0.2rem;
    flex-direction: column;
    display: flex;
    align-items: center;
    font-size: 0.26rem;
    margin-top: 0.5rem;
    table {
      width: 100%;
      .header {
        color: #888888;
        line-height: 0.4rem;
        th:first-child {
          width: 15%;
        }
        th:last-child {
          width: 10%;
        }
      }
      .content {
        line-height: 0.6rem;
      }
    }
    .title {
      font-size: 0.26rem;
      text-align: left;
      font-weight: bold;
      margin: 0.2em 0 0.5em 0;
    }
  }
}
</style>
